import { Component, OnInit } from '@angular/core';
import { OdrService } from '../service/odr.service';
import { Link } from '../shared/models/link';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  odrlink : Link;

  constructor(private OdrService: OdrService) { }

  ngOnInit(): void {
    //this.getOdrLink();
  }

  getOdrLink(): void {
    this.OdrService.getOdrLink().subscribe(o => 
      this.odrlink = o);
  }
}
